import { formatDate, getTags } from '@core/utils';
import type { PostOrPage, Tag } from '@tryghost/content-api';
import Image from 'next/image';
import Link from 'next/link';

interface BlogProps {
    blog: PostOrPage;
    readMoreURL?: string;
}

export default function Blog({
    blog: {
        feature_image,
        feature_image_alt,
        title,
        tags,
        excerpt,
        published_at,
        slug
    },
    readMoreURL
}: BlogProps) {
    return (
        <div className="w-full relative overflow-hidden rounded-xl border border-solid border-neutral-200 bg-neutral-100">
            {feature_image ?
                (
                    <div className="w-full h-40 relative">
                        <Link href={readMoreURL ? readMoreURL : `/brand/blogs/${slug}`} prefetch={false}>
                            <Image
                                src={feature_image}
                                alt={feature_image_alt ? feature_image_alt : 'blog thumbnail'}
                                fill
                                className="absolute inset-0 object-cover"
                            />
                        </Link>
                    </div>
                ) : (
                    <></>
                )}
            <div className="p-4 flex flex-col gap-2.5">
                <Link href={readMoreURL ? readMoreURL : `/brand/blogs/${slug}`} prefetch={false}>
                    <div className="space-y-1">
                        <h6 className="text-base text-neutral-800 font-semibold text-ellipsis line-clamp-1">{title}</h6>
                        <div className="flex gap-2">{getTags(tags).map((tag: Tag) => {
                            return <span className="uppercase text-xs px-1 border border-brand-500 text-red border-solid rounded">{tag.name}</span>
                        })}</div>
                        <span className="text-[14px] text-neutral-600 font-medium">Published: {formatDate(published_at)}</span>
                    </div>
                    <div className="flex flex-col items-start gap-2">
                        <p className="text-sm text-neutral-600 font-medium text-ellipsis line-clamp-2">
                            {excerpt}
                        </p>
                        <button
                            type="button"
                            className="px-0 text-sm text-brand-500 font-manrope font-medium hover:underline underline-offset-2 hover:cursor-pointer">
                            Read More
                        </button>
                    </div>
                </Link>
            </div>
        </div>
    );
}
